<script>
import {
    eventGroupState,
    isSelectedEventGroupLocked
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    commitHistory
} from '@app/store/historyStore.svelte.js';
import { clickoutside } from '@svelte-put/clickoutside';
import { toast } from "@zerodevx/svelte-toast";
import * as m from '@app/paraglide/messages.js';

let showDropdown = $state(false);

const alignRight = () => {
    applyAlignment('align right', 'right', 'end');
}

const applyAlignment = (actionName, alignment, xPos) => {
    if (isSelectedEventGroupLocked()) {
        toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
        return;
    }

    if (window.quillEditor){
        window.quillEditor.formatLine(0, 9999, 'align', alignment, "silent");
    }

    const egIdx = projectState.selected;
    const selected = [...eventGroupState[egIdx].selected];

    commitHistory({
        name: actionName,
        eventGroup: egIdx,
        mutate: {
            eventGroupState: (draft) => {
                selected.forEach((eventIndex) => {
                    draft[egIdx].events[eventIndex].alignment = alignment || "left";
                    draft[egIdx].events[eventIndex].xPos = xPos;
                });
            },
        },
    });
    
    showDropdown = false;
}

const toggleDropdown = () => {
    showDropdown = !showDropdown;
}

const closeDropdown = () => {
    showDropdown = false;
}

const leftJustifyRightPos = () => applyAlignment('left justify / right position', '', 'end');
const centerJustifyRightPos = () => applyAlignment('center justify / right position', 'center', 'end');
const rightJustifyRightPos = () => applyAlignment('right justify / right position', 'right', 'end');

let isDisabled = $derived(!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0 || isSelectedEventGroupLocked());
</script>

<li class="nav-item" title={m.align_right_title()}>
    <div class="btn-group btn-group-sm" role="group" use:clickoutside onclickoutside={closeDropdown}>
        <button 
            type="button" 
            class="btn btn-link nav-link" 
            id="align-right-btn"
            aria-label={m.align_right_aria_label()}
            disabled={isDisabled}
            onclick={alignRight}
        >
            <i class="bi bi-text-right"></i>
        </button>
        <button 
            type="button" 
            class="btn btn-link nav-link dropdown-toggle dropdown-toggle-split" 
            aria-expanded={showDropdown}
            disabled={isDisabled}
            onclick={toggleDropdown}
        >
            <span class="visually-hidden">{m.toggle_dropdown()}</span>
        </button>
        <ul class="dropdown-menu" class:show={showDropdown}>
            <li><a class="dropdown-item" href="#!/" onclick={leftJustifyRightPos}>{m.align_right_left_justify_right_pos()}</a></li>
            <li><a class="dropdown-item" href="#!/" onclick={centerJustifyRightPos}>{m.align_right_center_justify_right_pos()}</a></li>
            <li><a class="dropdown-item" href="#!/" onclick={rightJustifyRightPos}>{m.align_right_right_justify_right_pos()}</a></li>
        </ul>
    </div>
</li>
<style>
    .dropdown-menu {
        position: relative;
        top: 30px;
        left: 15px;
    }
</style>